import { v4 as uuidv4 } from 'uuid';

// `t-` and a lowercase UUID v4. The live chat API refuses any other thread id
// (services-sure: live_chat_access.THREAD_ID_PATTERN), so keep the two in step.
const THREAD_ID_PATTERN = /^t-[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

export const newThreadId = () => `t-${uuidv4()}`;

export const isValidThreadId = (value) =>
  typeof value === 'string' && THREAD_ID_PATTERN.test(value);
